import { ShipmentEvent } from './';

export class ShipmentMilestoneAssociatedEvent extends ShipmentEvent {
  milestoneEventId?: number;

  constructor(opts?: Partial<ShipmentMilestoneAssociatedEvent>) {
    super(opts);
    if (opts?.milestoneEventId != null) {
      this.milestoneEventId = opts.milestoneEventId;
    }
  }

  get isMilestone(): boolean {
    return false;
  }
}
